export var StorageType;
(function (StorageType) {
    StorageType["IPFS"] = "IPFS";
    StorageType["WEB3_STORAGE"] = "WEB3_STORAGE";
})(StorageType || (StorageType = {}));
//# sourceMappingURL=storageType.enum.js.map